// extracted by mini-css-extract-plugin
export default {"tabs":"Nav_tabs__ASsDO"};